function decToHex(dec: number): string {
    return `0${dec.toString(16)}`.substr(-2);
}

export const generateId = (len: number): string => {
    const arr = new Uint8Array((len || 40) / 2);
    window.crypto.getRandomValues(arr);
    return Array.from(arr, decToHex).join("");
};
